import React, { useState } from "react";
import InputBar from "../../components/FleetCoachDriverMappingV2/InputBar";
import MappingsList from "../../components/FleetCoachDriverMappingV2/IssuedList";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as FleetCoachDriverMappingActions from "../../store/actions/FleetCoachDriverMappingV2";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import ListPagination from "../../components/Common/ListPagination";

const FleetCoachDriverMapping = (props) => {
  const {
    getFleetCoachDriverMappingList,
    setFleetCoachDriverMappingActiveFilters,
    fleetCoachDriverMappingList,
    prevPage,
    nextPage,
    activeFilters,
  } = props;

  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const handleCredsChange = (states) => {
    setError("");
    const filter = [];
    const pagerequest = {
      page: currentPage,
      page_size: 10,
    };
    Object.keys(states).map((key) => {
      if (states[key] !== "") {
        filter.push({ key: key, value: states[key] });
      }
    });

    setFleetCoachDriverMappingActiveFilters(filter);
    getFleetCoachDriverMappingList(filter, pagerequest);
  };

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
      props.getFleetCoachDriverMappingList(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
      props.getFleetCoachDriverMappingList(activeFilters, pageRequest);
    }
  };

  return (
    <div className="container">
      <FlexContainer align="flex-start">
        <Heading>Fleet Coach Driver Mappings</Heading>
        <InputBar handleSubmit={handleCredsChange} />
      </FlexContainer>
      <MappingsList list={fleetCoachDriverMappingList} />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {error && <div className="error-state">{"*" + error}</div>}
    </div>
  );
};

function mapStateToProps(state) {
  const { FleetCoachDriverMapping } = state;
  return {
    fleetCoachDriverMappingList:
      FleetCoachDriverMapping.fleetCoachDriverMappingList,
    prevPage: FleetCoachDriverMapping.prevPage,
    nextPage: FleetCoachDriverMapping.nextPage,
    activeFilters: FleetCoachDriverMapping.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getFleetCoachDriverMappingList: bindActionCreators(
      FleetCoachDriverMappingActions.getFleetCoachDriverMappingList,
      dispatch
    ),
    setFleetCoachDriverMappingActiveFilters: bindActionCreators(
      FleetCoachDriverMappingActions.setFleetCoachDriverMappingActiveFilters,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FleetCoachDriverMapping);
